import { FOOTER_SIGNUP_DONE } from '../constants';

import { post } from '../Services/http';

export const signUpForNewsletter = (email) => (dispatch, getState) => {
    return post('/api/lime', { email })
        .then((response) => {
            if (response.status === 202) {
                dispatch(signupDone(true))
            }
        })
        .catch((ex) => {
            //catch error, display error message 
            console.log(ex)
        });
};



export const signupDone = () => ({
    type: FOOTER_SIGNUP_DONE,
    payload: {
        signupDone: true
    }
})